import { InsightWidget } from '@/store/beneficiary-insights/types'

import { ChartCard } from './ChartCard'
import { KPICard } from './KPICard'

export function Card({ widget }: { widget: InsightWidget }) {
  switch (widget.type) {
    case 'chart':
      return (
        <ChartCard title={widget.title} chart={widget.chart} description={widget.description} />
      )
    case 'kpi':
      return <KPICard title={widget.title} value={widget.value} description={widget.description} />
  }
}
